"use strict";

let gametimes_results = [];
let all_games = [];
let account_game_maps = [];
let current_page = 0;
const PAGE_SIZE = 1000;

checkQuota();
function checkQuota() {
    loadJSON(`${window.location.origin}/api/quota?api_key=${encodeURIComponent(getParameterByName("api_key"))}`).then(result => {
        $("s10").innerHTML = result.remaining;
    }).catch(console.error);
}

async function apiSubmit() {
    $("b1").disabled = true;
    $("results").innerHTML = "";
    gametimes_results = [];

    const raw_input = $("t1").value;
    const entries = raw_input.split("\n").map(s => s.trim()).filter(s => s.length > 0);

    if (entries.length === 0) {
        $("output1").value = "Please enter at least one Riot ID.";
        $("b1").disabled = false;
        return;
    }

    const parsed = [];
    for (const entry of entries) {
        const colon_idx = entry.indexOf(":");
        if (colon_idx === -1) {
            $("output1").value = `Invalid entry: "${entry}". Expected format: region:GameName#TAG`;
            $("b1").disabled = false;
            return;
        }
        const region = entry.substring(0, colon_idx).trim();
        const username = entry.substring(colon_idx + 1).trim();
        if (!region || !username) {
            $("output1").value = `Invalid entry: "${entry}". Expected format: region:GameName#TAG`;
            $("b1").disabled = false;
            return;
        }
        parsed.push({ region, username });
    }

    $("output1").value = `Starting search for ${parsed.length} account(s)...`;

    for (let i = 0; i < parsed.length; i++) {
        const { region, username } = parsed[i];
        $("output1").value = `Fetching ${i + 1}/${parsed.length}: ${region}:${username}`;
        try {
            const result = await loadJSON(
                `${window.location.origin}/api/gametimes/${encodeURIComponent(region.toUpperCase())}/${encodeURIComponent(username)}?api_key=${encodeURIComponent(getParameterByName("api_key"))}`
            );
            gametimes_results.push({ input: { region, username }, data: result, error: null });
        } catch (e) {
            gametimes_results.push({ input: { region, username }, data: null, error: e });
        }
    }

    $("output1").value = `Done. Fetched data for ${gametimes_results.length} account(s).`;
    renderResults();
    $("b1").disabled = false;
}

function gameOverlaps(a, b) {
    // Returns true if game a and game b overlap in time.
    // duration is in seconds; start is in ms.
    const a_end = a.start + (a.duration != null ? a.duration * 1000 : 0);
    const b_end = b.start + (b.duration != null ? b.duration * 1000 : 0);
    return a.start < b_end && b.start < a_end;
}

function renderResults() {
    const container = $("results");
    container.innerHTML = "";

    if (gametimes_results.length === 0) return;

    // Build global game list: unique mids across all accounts, sorted by start descending (most recent first).
    const mid_to_game = new Map();
    for (const result of gametimes_results) {
        if (!result.data || !result.data.games) continue;
        for (const game of result.data.games) {
            if (!mid_to_game.has(game.mid)) {
                mid_to_game.set(game.mid, game);
            }
        }
    }

    if (mid_to_game.size === 0) {
        container.textContent = "No game data to display.";
        return;
    }

    all_games = Array.from(mid_to_game.values()).sort((a, b) => b.start - a.start);

    // For each account, build a set of mids and an array of games for time overlap checks.
    account_game_maps = gametimes_results.map(result => {
        if (!result.data || !result.data.games) return { mid_set: new Set(), games: [] };
        return {
            mid_set: new Set(result.data.games.map(g => g.mid)),
            games: result.data.games
        };
    });

    current_page = 0;
    renderPage(0);
}

function renderPage(page) {
    const container = $("results");
    container.innerHTML = "";

    const total_pages = Math.ceil(all_games.length / PAGE_SIZE);
    const page_games = all_games.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

    // Pagination controls.
    const controls = document.createElement("div");
    controls.style.marginBottom = "6px";

    const prev_btn = document.createElement("button");
    prev_btn.textContent = "← Prev";
    prev_btn.disabled = page === 0;
    prev_btn.onclick = function() { current_page--; renderPage(current_page); };

    const next_btn = document.createElement("button");
    next_btn.textContent = "Next →";
    next_btn.disabled = page >= total_pages - 1;
    next_btn.onclick = function() { current_page++; renderPage(current_page); };

    const page_label = document.createElement("span");
    page_label.style.margin = "0 10px";
    page_label.textContent = `Games ${page * PAGE_SIZE + 1}–${Math.min((page + 1) * PAGE_SIZE, all_games.length)} of ${all_games.length} (page ${page + 1} of ${total_pages})`;

    controls.appendChild(prev_btn);
    controls.appendChild(page_label);
    controls.appendChild(next_btn);
    container.appendChild(controls);

    // Build table.
    const table = document.createElement("table");
    table.className = "playtime-table";

    // Header row.
    const thead = document.createElement("thead");
    const header_row = document.createElement("tr");
    ["Account", "Games"].forEach(text => {
        const th = document.createElement("th");
        th.textContent = text;
        header_row.appendChild(th);
    });
    thead.appendChild(header_row);
    table.appendChild(thead);

    // Body rows.
    const tbody = document.createElement("tbody");

    for (let ai = 0; ai < gametimes_results.length; ai++) {
        const result = gametimes_results[ai];
        const label = result.data && result.data.exact_ign
            ? `${result.data.region}:${result.data.exact_ign}`
            : `${result.input.region}:${result.input.username}`;

        const tr = document.createElement("tr");

        // Account cell.
        const td_account = document.createElement("td");
        td_account.textContent = label;
        td_account.className = "playtime-account";
        tr.appendChild(td_account);

        // Games cell.
        const td_games = document.createElement("td");
        td_games.className = "playtime-games";

        if (result.error || !result.data || !result.data.games) {
            const err_span = document.createElement("span");
            err_span.textContent = result.error ? `Error: ${result.error.message}` : "No data";
            err_span.style.color = "gray";
            td_games.appendChild(err_span);
        } else {
            const this_acc = account_game_maps[ai];

            // First pass: compute per-game display info.
            const game_infos = page_games.map(game => {
                const x_has_this_mid = this_acc.mid_set.has(game.mid);
                const others_share_mid = gametimes_results.some((_, other_ai) => {
                    if (other_ai === ai) return false;
                    return account_game_maps[other_ai].mid_set.has(game.mid);
                });
                const x_game_overlapping = this_acc.games.find(g => gameOverlaps(g, game));
                const others_overlap = gametimes_results.some((_, other_ai) => {
                    if (other_ai === ai) return false;
                    return account_game_maps[other_ai].games.some(g => gameOverlaps(g, game));
                });

                let color;
                if (x_has_this_mid && others_share_mid) {
                    color = "magenta";
                } else if (x_game_overlapping && others_overlap) {
                    color = (x_game_overlapping.a === true || game.a === true) ? "orange" : "red";
                } else if (x_game_overlapping) {
                    color = "lime";
                } else {
                    color = "";
                }

                const is_clickable = (color === "magenta" || color === "red" || color === "orange") && result.data.region;
                const link_mid = is_clickable ? (color === "magenta" ? game.mid : x_game_overlapping.mid) : null;
                const title_game = (color === "red" || color === "orange") ? x_game_overlapping : game;
                const title = color ? `mid: ${title_game.mid}, start: ${new Date(title_game.start).toISOString()}, duration: ${title_game.duration != null ? title_game.duration + "s" : "unknown"}${title_game.duration != null ? ", end: " + new Date(title_game.start + title_game.duration * 1000).toISOString() : ""}` : "";

                return { color, is_clickable, link_mid, title };
            });

            // Second pass: group consecutive entries with the same link_mid and emit grouped elements.
            let gi = 0;
            let underline_toggle = true;
            while (gi < game_infos.length) {
                const info = game_infos[gi];
                // Find run length: consecutive entries sharing the same link_mid (only group clickable ones).
                let run = 1;
                if (info.is_clickable && info.link_mid !== null) {
                    while (gi + run < game_infos.length &&
                           game_infos[gi + run].link_mid === info.link_mid) {
                        run++;
                    }
                }

                const exclamations = "!".repeat(run);

                if (info.is_clickable) {
                    const link_mid = info.link_mid;
                    const match_stats_url = `https://rewind.lol/getmatch/${result.data.region}/${link_mid}/stats`;
                    const timeline_url = `https://rewind.lol/getmatch/${result.data.region}/${link_mid}/timeline`;
                    const href = `https://iaace-na.github.io/lol-match-stats-viewer/?match=${encodeURIComponent(match_stats_url)}&timeline=${encodeURIComponent(timeline_url)}`;
                    const anchor = document.createElement("a");
                    anchor.href = href;
                    anchor.target = "_blank";
                    anchor.style.color = info.color;
                    if (run > 1) {
                        anchor.style.textDecoration = underline_toggle ? "underline" : "overline";
                        underline_toggle = !underline_toggle;
                    } else {
                        anchor.style.textDecoration = "none";
                    }
                    anchor.title = game_infos[gi].title;
                    anchor.textContent = exclamations;
                    td_games.appendChild(anchor);
                } else {
                    const span = document.createElement("span");
                    span.textContent = exclamations;
                    if (info.color) {
                        span.style.color = info.color;
                        span.title = info.title;
                    }
                    td_games.appendChild(span);
                }

                gi += run;
            }
        }

        tr.appendChild(td_games);
        tbody.appendChild(tr);
    }

    table.appendChild(tbody);
    container.appendChild(table);
}

function loadJSON(path) {
    return fetch(path).then(response => {
        if (response.status === 200) {
            return response.json();
        }
        return Promise.reject(new Error(`HTTP ${response.status}`));
    });
}

function $(id) {
    return document.getElementById(id);
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
